<div class="main-page-section default_font p-3 p-md-4 px-lg-5">
    <div class="breadcrumbs-section p-0 mb-3 mb-md-4 mb-lg-5">
        <span class="prev-page pr-1 prev"><a routerLink="/overview">Home</a></span>
        <span class="separator">&nbsp; &nbsp;</span>
        <img src="../../assets/images/seperator.png">
        <span class="separator">&nbsp; &nbsp;</span>
        <span class="curr-page pl-1 breadcrumbs-section-font">Add New Plant/Trees Information</span>
    </div>
    <div class="d-flex align-items-center justify-content-between mb-3 mb-md-4">
        <h2 class="font-weight-medium mb-3 mb-md-4">Add New Plant/Trees Information</h2>

        <button class="btn btn-primary" (click)="goToBulkUploadPage()">Bulk Upload</button>

        <!-- <button class="btn btn-primary" (click)="bulkuploadfile.click()">Bulk Upload</button>
        <input onclick="this.value = null" name="file" id="file" type="file" class="d-none"
            accept=".csv, .xlsx, .xls" (change)="onBulkUploadChange($event)" #bulkuploadfile> -->
    </div>

    <!-- form start -->
    <form [formGroup]="myForm" (ngSubmit)="onSubmit()" enctype="multipart/form-data">
        <!-- ROOT CAUSE FIX: Removed ngb-panel + ng-template ngbPanelContent to prevent blank page issues -->
        <ngb-accordion [activeIds]="activeIds" class="form_accordion">
            <!-- Plant Details Section -->
            <div class="mb-4 mb-md-5">
                <h5 class="mb-3 mb-md-4 font-weight-medium">Plant Details</h5>
                <div class="row row-gap-4">
                        <div class="col-12 col-md-6 col-lg-4 d-flex flex-column row-gap-1">
                            <div class="form-group floating_form_field mb-0 w-100">
                                <input type="text" formControlName="VegetationName" id="name" class="form-control"
                                    placeholder="Name" [(ngModel)]=mainPlant.VegetationName>
                                <label>Name</label>
                            </div>
                            <div *ngIf="myForm.get('VegetationName').invalid && myForm.get('VegetationName').touched"
                                class="small text-danger">
                                <div *ngIf="myForm.get('VegetationName').errors?.required">Name is required</div>
                                <div *ngIf="myForm.get('VegetationName').errors?.maxlength">The name may not be longer
                                    than 100
                                    charecters</div>
                            </div>
                        </div>
                        <div class="col-12 col-md-6 col-lg-4 d-flex flex-column row-gap-1">
                            <div class="form-group floating_form_field mb-0 w-100">
                                <input type="text" formControlName="Species" class="form-control" placeholder="Species"
                                    [(ngModel)]=mainPlant.Species>
                                <label>Species</label>
                            </div>
                            <div *ngIf="myForm.get('Species').invalid && myForm.get('Species').touched"
                                class="small text-danger">
                                <div *ngIf="myForm.get('Species').errors?.required">Species is required</div>
                            </div>
                        </div>
                        <div class="col-12 col-md-6 col-lg-4 d-flex flex-column row-gap-1">
                            <div class="d-flex align-items-center justify-content-between upload_field"
                                (click)="uploadImages.click()">
                                <span>Upload Images (Optional)</span>
                                <svg-icon src="../../../assets/images/icons/upload.svg"></svg-icon>
                            </div>
                            <input onclick="this.value = null" formControlName="file" id="file" type="file"
                                class="d-none" multiple accept=".png, .jpg, .jpeg" (change)="onFileChange($event)"
                                #uploadImages>
                        </div>
                        <div class="col-12" *ngIf="images.length">
                            <div class="row row-gap-3">
                                <div class="col-12 col-md-6 col-lg-4 col-xl-3"
                                    *ngFor='let image of images; let i = index;'>
                                    <div class="uploaded_images">
                                        <img [src]="image.imgBase64">
                                        <span class="crop_icon" *ngIf="!image.cropped" (click)="openModal(content, i)">
                                            <svg-icon src="../../../assets/images/icons/crop.svg"></svg-icon>
                                        </span>
                                        <span class="remove_icon" (click)="removeImage(i)">
                                            <svg-icon src="../../../assets/images/icons/close.svg"></svg-icon>
                                        </span>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <!-- <div class="col-12 text-right" *ngIf="images?.length > 0">
                            <button type="button" class="btn btn-outline-primary" (click)="SaveAllImages()">Save
                                All</button>
                        </div> -->
                        <ng-template #content let-modal>
                            <div class="modal-header">
                                <h4 class="modal-title">Image Cropper</h4>
                                <button type="button" class="close" aria-label="Close" (click)="closeModal()">
                                    <svg-icon src="./assets/images/icons/close.svg"></svg-icon>
                                </button>
                            </div>
                            <div class="modal-body px-3">
                                <image-cropper [imageChangedEvent]="imageChangedEvent" [maintainAspectRatio]="true"
                                    [aspectRatio]="4 / 3" [cropperStaticWidth]="200" [cropperStaticHeight]="150"
                                    format="png" (imageCropped)="imageCropped($event)" (imageLoaded)="imageLoaded()"
                                    (cropperReady)="cropperReady()" (loadImageFailed)="loadImageFailed()"
                                    output="blob"></image-cropper>
                            </div>
                            <div class="modal-footer border-light">
                                <button type="button" class="btn btn-clear" (click)="closeModal()">Cancel</button>
                                <button type="button" class="btn btn-primary" (click)="SaveCropedImage()">Crop</button>
                            </div>
                        </ng-template>
                    </div>
            </div>
            <!-- Location Details Section -->
            <div class="mb-4 mb-md-5 border-top border-light pt-4 pt-md-5">
                <h5 class="mb-3 mb-md-4 font-weight-medium">Location Details</h5>
                <div class="row row-gap-4">
                        <div class="col-12 col-md-6 col-lg-4 d-flex flex-column row-gap-1">
                            <div class="form-group floating_form_field mb-0 w-100">
                                <select class="form-control" formControlName="ParkId" [(ngModel)]=mainPlant.ParkId>
                                    <option value="">Select Location</option>
                                    <!-- <option value="6640d105-6482-4a55-aaf0-492f86637aec">ITPB(Bangalore)</option> -->
                                    <option value="{{park.parkId}}" *ngFor="let park of prakList">{{park.parkName}}
                                    </option>
                                </select>
                                <label>Location</label>
                            </div>
                            <div *ngIf="myForm.get('ParkId').invalid && myForm.get('ParkId').touched"
                                class="small text-danger">
                                <div *ngIf="myForm.get('ParkId').errors?.required">Location is required</div>
                            </div>
                        </div>
                    </div>
            </div>
            <!-- Notes Section -->
            <div class="mb-4 mb-md-5 border-top border-light pt-4 pt-md-5">
                <h5 class="mb-3 mb-md-4 font-weight-medium">Notes</h5>
                <div class="row row-gap-4" formArrayName="VegetationNotes">
                        <div class="col-12 col-lg-8">
                            <div class="bg-lighter border border-light rounded p-3 p-md-4 mb-3 mb-md-4 position-relative"
                                *ngFor="let item of VegetationNotes().controls; let i=index" [formGroupName]="i">
                                <div class="d-flex flex-column row-gap-4">
                                    <div class="d-flex flex-column row-gap-1">
                                        <div class="form-group floating_form_field mb-0 w-100">
                                            <input type="text" class="form-control" placeholder="Add Headline"
                                                formControlName="headline" maxlength="200">
                                            <label *ngIf="i > 0">Add Headline</label>
                                            <label *ngIf="i == 0">Overview</label>
                                        </div>
                                        <div class="d-flex justify-content-between">
                                            <div *ngIf="VegetationNotes().controls[i].get('headline').invalid && VegetationNotes().controls[i].get('headline').touched"
                                                class="small text-danger">
                                                <div
                                                    *ngIf="VegetationNotes().controls[i].get('headline').errors?.required">
                                                    Headline is required
                                                </div>
                                            </div>
                                            <div class="small text-muted ml-auto">Max 200 chars allowed.</div>
                                        </div>
                                    </div>
                                    <div class="d-flex flex-column row-gap-1">
                                        <div class="form-group floating_form_field mb-0 w-100">
                                            <textarea class="form-control" placeholder="Add Text"
                                                formControlName="description" maxlength="1000"></textarea>
                                            <label *ngIf="i > 0">Add Text</label>
                                            <label *ngIf="i == 0">Add Details</label>
                                        </div>
                                        <div class="d-flex justify-content-between">
                                            <div *ngIf="VegetationNotes().controls[i].get('description').invalid && VegetationNotes().controls[i].get('description').touched"
                                                class="small text-danger">
                                                <div
                                                    *ngIf="VegetationNotes().controls[i].get('description').errors?.required">
                                                    Description is
                                                    required
                                                </div>
                                            </div>
                                            <div class="small text-muted ml-auto">Max 1000 chars allowed.</div>
                                        </div>
                                    </div>
                                </div>
                                <button *ngIf="i !== 0" (click)="removeBlock(i)" class="btn btn-danger card_remove">
                                    <svg-icon src="../../../assets/images/icons/close.svg"></svg-icon>
                                </button>
                            </div>
                        </div>
                    </div>
                    <div>
                        <span class="text-primary font-weight-bold cursor-pointer" (click)="addMore()">+ Add More</span>
                    </div>
            </div>
        </ngb-accordion>
        <div
            class="py-3 py-md-4 border-top border-light mt-3 mt-md-4 d-flex align-items-center justify-content-end column-gap-3">
            <button class="btn btn-clear text-muted" type="button">Cancel</button>
            <button class="btn btn-primary" type="submit">Submit</button>
        </div>
    </form>
    <!-- form end -->
</div>